import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "live-win" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "username" }
const _hoisted_5 = { class: "win" }
const _hoisted_6 = { class: "amount hidden" }
const _hoisted_7 = { class: "amount" }
const _hoisted_8 = { class: "multiplier" }
const _hoisted_9 = { class: "duration" }

import {numberFormatter} from "@/service/NumberFormatter";
import LiveWinDTO from "@/models/LiveWinDTO";
import {nowState, userTimeZone} from "@/service/DateHelper";
import {computed, onMounted, ref} from "vue";
import moment from "moment-timezone";
import {$t} from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'LiveWin',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props

const displayValue = ref(props.item.win.amount);

const durationLabel = computed(() => {
  const m = (moment(props.item.createdAt)).utcOffset(0).tz(userTimeZone())

  const seconds = moment(nowState.now).diff(m, "seconds");
  if (seconds < 60) return $t('time_ago.seconds', {seconds});

  const minutes = moment(nowState.now).diff(m, "minutes");
  if (minutes < 60) return $t('time_ago.minutes', {minutes});

  const hours = moment(nowState.now).diff(m, "hours");
  if (hours < 24) return $t('time_ago.hours', {hours});

  const days = moment(nowState.now).diff(m, "days");
  return $t('time_ago.days', {days});
})

const animateValue = (from: number, to: number, duration = 800) => {
  const start = performance.now();

  function frame(now: number) {
    const progress = Math.min((now - start) / duration, 1);
    const value = from + (to - from) * progress;

    displayValue.value = Math.floor(value).toString()
    if (progress < 1) {
      requestAnimationFrame(frame);
    }
  }
  requestAnimationFrame(frame);
}

onMounted(() => {
  animateValue(0, Number.parseFloat(props.item.win.amount));
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.item.gameIcon,
      class: "game-icon"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.userLabel), 1),
      _createElementVNode("div", _hoisted_5, [
        _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(numberFormatter).formatNumber(props.item.win.amount)), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(numberFormatter).formatNumber(displayValue.value)), 1),
        _createElementVNode("span", _hoisted_8, "x" + _toDisplayString(_unref(numberFormatter).formatNumber(_ctx.item.multiplier, 0)), 1)
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(durationLabel.value), 1)
    ])
  ]))
}
}

})